export default __webpack_public_path__ + "static/media/banner7.437ed56c.png";